import { managerApiUrl } from "./manager-api";
import { baseFetch } from "./utils.ts/base-fetch";

export type ImageType = {
  status: boolean;
  thumbnail: string;
  normal: string;
};
const baseUrl = `${managerApiUrl}/image`;

export const postImage = async (formData: FormData): Promise<ImageType> => {
  const response = await baseFetch(baseUrl, {
    method: 'POST',
    body: formData,
  });
  return response;
};
